import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { LENGTH_TO_SHOW_TITLE_IN_RECENT_SEARCH_ITEM } from '../../SmartSearch.constants.js'
import { useRecentSearch } from './hooks/index.js'

type Props = {
  searchTerm: string
  onClick: (searchTerm: string) => void
}

export const RecentSearchItem = ({ searchTerm, onClick }: Props) => {
  const { remove } = useRecentSearch()

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation()
    remove(searchTerm)
  }

  return (
    <Button
      variant="secondaryNeutral"
      size="md"
      className="rounded-full flex-shrink-0 !max-w-52 overflow-hidden"
      onClick={() => onClick(searchTerm)}
      title={
        searchTerm.length > LENGTH_TO_SHOW_TITLE_IN_RECENT_SEARCH_ITEM
          ? searchTerm
          : undefined
      }
      leadingIcon={
        <SvgIcon
          name="search"
          size="lg"
          className="text-content-on-background-subdued"
        />
      }
      trailingIcon={
        <SvgIcon
          name="close"
          size="lg"
          onClick={e => handleClear(e)}
          className="text-action-secondary ms-1 lg:ms-0"
        />
      }
    >
      {/* eslint-disable-next-line react/jsx-no-literals */}
      {`'${searchTerm}'`}
    </Button>
  )
}
